"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgViber = function SvgViber(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.413,
    height: 23.413,
    fill: "#7D519E",
    rx: 11.707
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m8.024 19.198 1.38-1.558.285.062c.42.09.85.137 1.287.137h1.784a6.043 6.043 0 0 0 0-12.086h-1.784A6.043 6.043 0 0 0 7.788 16.93l.236.146v2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.433 10.277c-.36.29-.619.36-.537.919.081.558.562 1.189.778 1.376.216.187 1.104 1.015 1.503 1.081.4.066.64-.078.727-.217a4.6 4.6 0 0 1 .42-.51c.246-.254.532-.254.857 0 .325.253.836.641 1.533 1.163.329.239.329.57 0 .991-.33.422-.62.73-.875.923-.433.173-.881.117-1.345-.167-.697-.426-2.24-1.043-3.48-2.4-.826-.905-1.628-2.108-2.407-3.61-.228-.69-.228-1.174 0-1.447.228-.274.523-.518.884-.734.38-.172.683-.112.911.18.228.291.592.787 1.092 1.486.2.45.18.772-.06.966z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M11.992 9.347c1.822-.07 2.692.757 2.613 2.479m-2.649-3.937c2.89-.11 4.272 1.201 4.145 3.934"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgViber);
var _default = exports["default"] = Memo;